import userAtom from "@/atoms/userAtom";
import type { ReviewerDetail } from "@/hooks/methodology/useReviewerDecisions";
import { UserRole } from "@/types/Role";
import { useAtom } from "jotai";
import { useRouter } from "next/router";
import { FeedbackBadge } from "../shared/ui/Badges";

type IPropType = {
	reviewer: ReviewerDetail;
	isClickable?: boolean;
};

const ReviewerDecisionCard = (props: IPropType) => {
	const [user] = useAtom(userAtom);
	const role = user?.roles[0];
	const { reviewer, isClickable } = props;
	const router = useRouter();

	const handleCardClick = () => {
		if (!isClickable) {
			return;
		}
		if (!reviewer.reviewerUserId) {
			return;
		}
		if (role == UserRole.ADMIN) {
			router.push(`/admin/tools/reviewer/${reviewer.reviewerUserId}`);
			return;
		}
		router.push(`/all-methodologies/reviewer/${reviewer.reviewerUserId}`);
	};

	return (
		<div
			onClick={handleCardClick}
			role="presentation"
			className={`${isClickable ? "cursor-pointer" : "cursor-default"}`}
		>
			<div className="my-4 mr-4 flex h-fit min-w-[30rem] flex-row space-x-4 rounded bg-white p-6 hover:shadow-md">
				<div className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-black text-xl font-bold text-white">
					{reviewer.name?.charAt(0).toUpperCase() || reviewer.email?.charAt(0).toUpperCase() || "n/a"}
				</div>
				<div className="space-y-2">
					<h6 className="">{reviewer.name || reviewer.email || "n/a"}</h6>
					<div>
						{reviewer?.organization?.split(", ").map((institute, index) =>
							index > 0 ? (
								<></>
							) : (
								<p className="font-geist-mono text-xs" key={institute}>
									{reviewer.role?.split(", ")[index]} at {institute}
								</p>
							),
						)}
						{!reviewer?.organization && !!reviewer?.role && (
							<p className="font-geist-mono text-xs">{reviewer.role.split(", ")?.pop() ?? ""}</p>
						)}
					</div>
					{!reviewer.nonVoting && <FeedbackBadge decision={reviewer.decision} />}
				</div>
			</div>
		</div>
	);
};

export default ReviewerDecisionCard;
